module.exports = __webpack_public_path__ + "static/media/city-carlow.39a7be16.png";